// global search

var swiper = new Swiper(".swiper", {
    slidesPerView: 3,
    spaceBetween: 30,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
});

$(document).keypress(function(e) {

});


$(document).ready(function() {



    // init slick slider
    $('.slider').slick({
        slidesToShow: 2.35,
        arrows: true,
        dots: false,
        infinite: false,
        initialSlide: 0,
        prevArrow: $('.slider-prev'),
        nextArrow: $('.slider-next'),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2.35,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1.35,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1.25,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.clickable').click(function(){
        if($(this).find("a").length){
            window.location.href = $(this).find("a:first").attr("href");
        }
    });

    $('.exchange-detail svg').hover(function() {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).parent().find('p').hide();
        } else {
            $('.exchange-detail p').hide();
            $(this).addClass('active');
            $(this).parent().find('p').toggle();
        }

    });

    $('.media-video').click(function() {
        var videoId = $(this).attr('data-video');
        var parent = $(this).parents('.element').find('.embed-container')
        var image = $(this);
        var video = '<iframe width="560" height="315" src="https://www.youtube.com/embed/'+videoId+'?rel=0&amp;showinfo=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
        //$(image).css('opacity', '0');
        $(parent).append(video);
    });


});

$(window).on('load scroll resize', function() {
    // trigger animations on viewport visible
    $('.element').each(function() {
        var rel = $(this).attr('rel');
        if( $(this).isFullyVisible() ) {
            $(this).addClass('visible')
            $('.page-navigation li').removeClass('active');
            $('.page-navigation li[rel="'+rel+'"]').addClass('active');
        } else {
            $(this).removeClass('visible')
        }
    });


    $('.element .animation').each(function() {
        if( $(this).isFullyVisible() ) {
            $(this).addClass($(this).attr('data-animate'));
            $(this).addClass('visible');

        } else {
            //$(this).removeClass($(this).attr('data-animate'));
            $(this).removeClass('visible');

        }
    });
});